import { render, staticRenderFns } from "./VisitsCurrent.vue?vue&type=template&id=721c1e94&"
import script from "./VisitsCurrent.vue?vue&type=script&lang=js&"
export * from "./VisitsCurrent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports